import axios from "axios";

export function loadSongsAPI() {
  const metaData = {
    withCredentials: true,
  };

  return new Promise((resolve) => {
    axios
      .get(`${process.env.REACT_APP_BACKEND}/songs`, metaData)
      .then((response) => {
        resolve(response.data);
      })
      .catch((e) => {
        resolve(e);
      });
  });
}
